import { render, staticRenderFns } from "./TravelFilter.vue?vue&type=template&id=1b3c66be"
import script from "./TravelFilter.vue?vue&type=script&lang=ts"
export * from "./TravelFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports